import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Navbar from "react-bootstrap/Navbar";
import { useDispatch } from "react-redux";
import Nav from 'react-bootstrap/Nav';
import { useNavigate } from "react-router-dom";
import '../../Styles/tetdsc.css';
import { FiArrowRight, } from "react-icons/fi";
import { MdOutlineLocalPostOffice } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import { HiOutlineArrowRight } from "react-icons/hi2";
import WavingCircleFlag from './CircleFlag.js';
import DotAnimation from "./DotAnimation";
import Notifications from "../Notifications.js";
import { config } from "../CommonUtilities/CommonUrl/CommonUrls";
import axios from "axios";
import moment from "moment";
import { ShowPDF } from "../CommonUtilities/CommonFunctions/CommonFunction";
import EmployeeLogin, { handleLogout } from "../../Auth/EmployeeLogin";
import DocumentsModal, { documentData } from "../DocumentsModal";
import { Modal, Table, Button, Carousel } from "react-bootstrap";
import CandidateLogin from "../../Auth/CandidateLogin";
import { InfoAlert2 } from "../CommonUtilities/CommonPopupAndAlerts/SweetAlerts.js";
import { RiHome2Line } from "react-icons/ri";
export default function Home1() {
  let navigate = useNavigate();
  const [showData, setShowData] = React.useState(false);
  const [chshow, setchshow] = React.useState(false);

  const [dshow, setdShow] = useState(false);
  const handledClose = () => setdShow(false);
  const handledCShow = () => setchshow(true);
   const handledDShow = () => setShowData(true);

  const [showExamKeys, setExamKeys] = useState([]);

  function renderExams() {
    let Url = config.url.CONTEXT_READ_URL + "kgbv-public/tet-paperwise-consolidated-key-path-details";
    axios.get(Url).then((res) => {
      if (res?.data?.status === true) {
        const keyData = res?.data?.data || [];
        const filteredKeyData = keyData.filter((val) => val?.consolidated_key_path);
        const formattedKeys = filteredKeyData?.map((val) => ({
          name: `${val?.post_name}-${val?.med_name}-${moment(val?.exam_dt).format("DD-MM-YYYY")} Shift ${val?.exam_shift}`,
          c_key: val?.consolidated_key_path,
          post: "Document",
          f_key: val?.final_key_path,
        }));
        setExamKeys(formattedKeys);
      } else {
        setExamKeys([]);
      }
    });
  }

  //   useEffect(() => {
  //   if (showExamKeys?.length > 0) {
  //     setDocumentModal({
  //       show: true,
  //       title: "APDSC-2025 Final Key",
  //       data: showExamKeys,
  //     });
  //   }
  // }, [showExamKeys]);

  let dispatch = useDispatch();
  useEffect(() => {
    handleLogout(dispatch, navigate);
  }, []);
//  const [showData, setShowData] = React.useState(false);
  const handleCShow = () => setchshow(true);
  const handleClose = () => {
    setShowData(false);
    setchshow(false);
  };

  const [documentModal, setDocumentModal] = React.useState({
    show: false,
    title: "",
    data: [],
  });

  const openDocumentModal = (title, dataKey) => {
    setDocumentModal({
      show: true,
      title: title,
      data: documentData[dataKey],
    });
  };

  const closeDocumentModal = () => {
    setDocumentModal({
      ...documentModal,
      show: false,
    });
  };

  const handleManualItemClick = (item) => {
    if (item.type === "document") {
      ShowPDF(item.url);
    } else if (item.type === "video") {
      window.open(item.url, "_blank");
    }
  };

  const [loading, setLoading] = useState(false);
  const [showGoPopup, setGopopup] = useState(false);
  const handleGoClose = () => setGopopup(false);

  let DSC_2025 = [
    {
      name: "Notification & Information Bulletin (School Education)", clickable: () => {
        handleGoClose();
        openDocumentModal("Notification & Information Bulletin (School Education)", "school")
      }
    },
    {
      name: "Notification & Information Bulletin (Residential Schools)", clickable: () => {
        handleGoClose(); openDocumentModal(
          "Notification & Information Bulletin (Residential Schools)",
          "society"
        )
      }
    },
    { name: "Subjects & Syllabus", clickable: () => { handleGoClose(); openDocumentModal("Subjects & Syllabus", "syllabus") } },
    { name: "MOCK TEST LINKS", clickable: () => { handleGoClose(); openDocumentModal("APDSC-2025 MOCK TEST LINKS", "MockTest") } },
    { name: "Final Key", clickable: () => { handleGoClose(); renderExams(); } },
    { name: "Post Vacancies (School Education)", clickable: () => { navigate("/SEPostVacancies") } },
    { name: "Post Vacancies (Residential Education)", clickable: () => { navigate('/REPostVacancies') } },
    { name: "Press Note", url: 'pressNote', clickable: () => { handleGoClose(); openDocumentModal("Press Note", "pressNote") } },
    { name: "Government Orders (GOs)", url: 'gos', clickable: () => { handleGoClose(); openDocumentModal("Government Orders (GOs)", "gos") } },
    { name: "Frequently Asked Questions", url: 'faqs', clickable: () => { handleGoClose(); openDocumentModal("Frequently Asked Questions", "faqs") } },
    { name: "User Manual", url: 'manuals', clickable: () => { handleGoClose(); openDocumentModal("User Manual", "manuals") } },
    { name: "Schedule", url: 'schedule', clickable: () => { handleGoClose(); openDocumentModal("Schedule", "schedule") } },
    { name: "Mega DSC General Merit List-2025", clickable: () => { navigate('/MeritList1') } },
  ]
  useEffect(() => {
    let data_key = showExamKeys;
    setExamKeys(data_key);
    if (showExamKeys?.length > 0) {
      setDocumentModal({
        show: true,
        title: "APTET-2025 Answer Keys",
        data: showExamKeys,
      });
    }
  }, [showExamKeys]);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50); // change after 50px
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <>
      <Modal show={showGoPopup} onHide={handleGoClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>DSC - 2025</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Table striped bordered hover>
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Details</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {DSC_2025 &&
                DSC_2025?.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}.</td>
                    <td>{item?.name}</td>
                    <td>
                      <Button
                        variant="success"
                        size="sm"
                        onClick={() => {
                          if (item?.clickable) {
                            item?.clickable(); // run custom function
                          } else {
                            navigate(item?.url); // or whatever navigation logic
                          }
                        }}
                      >
                        Click Here
                      </Button>
                    </td>

                  </tr>
                ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleGoClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* {config.url.status === 'dev' && <div className="dev-bg"></div>} */}
      <section id="tetdsc-banner-part">
        <div className="main-banner-part">
          <Navbar expand="lg" className={`tetdsc-navbar  ${scrolled ? "navbar-scrolled" : ""}`}>
            <Container fluid>
              <Navbar.Brand href="#" className="tetdsc-logoa">
                <div className="tetdsc-logo">
                  <img src="../img/ap-logo.webp" className="img-fluid" alt="ap-logo" />
                  <div className="tetdsc-logo-text">
                    <h5>KASTURBA GANDHI BALIKA VIDYALAYA (KGBV)</h5>
                    <h6>Government of Andhra Pradesh</h6>
                  </div>
                </div>
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="navbarScroll" />
              <Navbar.Collapse id="navbarScroll">
                <Nav className="me-auto my-2 my-lg-0" navbarScroll>
                </Nav>
                {/* <div className="tetdsc-login-buttons">
                  <a href="" className="home-icon">
                    <RiHome2Line />
                  </a>
                  <a href="#" 
                   onClick={(e) => {
                    e.preventDefault(); handleCShow();
                  }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleCShow();
                      }
                    }}
                  >
                    <div className="tetdsc-candidate">
                      <p>Candidate<br></br>Login</p>
                      <img src="../img/candidate-icon.webp" className="img-fluid" alt="candidate-icon" />
                    </div>
                  </a>
                  <a href="#" 
onClick={(e) => {
                    e.preventDefault(); handledDShow();
                  }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handledDShow();
                      }
                    }}
                    >
                    <div className="tetdsc-candidate">
                      <p>Department<br></br>Login</p>

                      <img src="../img/department-icon.webp" className="img-fluid" alt="department-icon" />
                    </div>
                  </a>
                </div> */}
              </Navbar.Collapse>
            </Container>
          </Navbar>
          <div className="banner-boxcontent">
            <Container>
              <Row className="banner-row mx-0">

                {/* LEFT RED BOX */}
                <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12}>
                  <div className="banner-box left-box">

                    <div className="banner-content">
                      <h2>
                        Kasturba Gandhi Balika Vidyalaya for holistic development
                        and empowerment of girls
                      </h2>

                      <div className="samgra-logodiv">
                        <div className="samknow-morebtn">
                          <Button variant="light" className="know-more-btn">
                            Know More
                          </Button>
                        </div>

                        <div className="samagra-logo">
                          <img
                            src="../img/samagra.svg"
                            alt="Samagra Shiksha"
                          />
                          <span>Samagra Shiksha</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12}>
                  <div className="banner-box right-box">
                    <div className="banner-content">

                      <Carousel fade slide={false}
                        indicators={false}
                        controls={false}
                        interval={3000}>
                        <Carousel.Item>
                          <div className="banner-content text-center">
                            <img
                              src="../img/cbn.png"
                              alt="CM"
                              className="cm-image"
                            />
                            <h5 className="cm-head mb-0">Sri Nara Chandrababu Naidu</h5>
                            <p className="cm-sub mb-0">Hon'ble Chief Minister</p>
                          </div>
                        </Carousel.Item>

                        <Carousel.Item>
                          <div className="banner-content text-center">
                            <img
                              src="../img/min.png"
                              alt="CM"
                              className="cm-image"
                            />
                            <h5 className="cm-head mb-0">Sri Nara Lokesh</h5>
                            <p className="cm-sub mb-0">Hon'ble Human Resource<br />Development Minister</p>
                          </div>
                        </Carousel.Item>
                      </Carousel>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </section>
      <section id="application-part">
        <Container>
          <Row className="mx-0">
            <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12}>
              <div className="application-box1">
                <h6>Application</h6>
                <div className="application-text">
                  <Row>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6} className="content-apborder">
                      <div className="content-application1">
                        <div>
                          <p>Start Date</p>
                          <h5>27/05/2026</h5>
                        </div>
                      </div>
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                      <div className="content-application2">
                        <div>
                          <p>End Date</p>
                          <h5>05/06/2026</h5>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6} className="mt-4 mt-lg-0">
              <div className="application-box2"
                onClick={() => {
                  // navigate('/ForgotPassword')
                   InfoAlert2("Coming Soon...!", "info");
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    // navigate('/ForgotPassword');
                     InfoAlert2("Coming Soon...!", "info");
                  }
                }}
              >
                <h6>Forgot Password?</h6>
                <img src="../img/forgot-password.svg" className="img-fluid" alt="forgot-img" />
                <HiOutlineArrowRight className="tet-arrow-icon" />
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6} className="mt-4 mt-lg-0">
              <div className="application-box3"
                onClick={() => {
                  // navigate('/RegistrationForm')
                  InfoAlert2("Coming Soon...!", "info");
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    // navigate('/RegistrationForm');
                    InfoAlert2("Coming Soon..!", "info");
                  }
                }}
              >
                <h6>Register Here</h6>
                <img src="../img/results.svg" className="img-fluid" alt="register-img" />
                <HiOutlineArrowRight className="tet-arrow-icon" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section id="columns">
        <Container>
          <Row className="align-items-center mx-0">
            <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={12} className="">
              <div className="teachers-all ">
                <h1 className="mb-0">About KGBV Schools</h1>
                <h6 className="span-div mb-0">Kasturba Gandhi Balika Vidyalaya
                  for holistic development and
                  empowerment of girls</h6>
                <p>Kasturba Gandhi Balika Vidyalayas (KGBVs) are the residential schools for girls setup in educationally backward blocks to ensure access and quality education to girls from disadvantaged and underprivileged sections of the society. They run from classes VI to XII.</p>
              </div>
            </Col>
            <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={12} className="mt-4 mt-xl-0">
              <Notifications handledCShow={handledCShow} />
              {/* <div className="notifications-all d-none">
                <h2>Notifications</h2>
                <ul>
                  <li><a href="#">AP TET July-2025 Examination Schedule</a></li>
                  <li><a href="#">AP TET Notification</a></li>
                  <li><a href="#">AP TET Information Bulletin</a></li>
                </ul>
                <div className="d-flex justify-content-end">
                  <button><FiArrowUp className="notific-arrow" /></button>
                  <button><FiArrowDown className="notific-arrow" /></button>
                </div>
              </div> */}
            </Col>
            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className="">
              <div className="options-all options-all1">
                <Row>
                  <Col xxl={3} xl={3} lg={3} md={4} sm={6} xs={6} className="mb-4">
                    <a href="#"
                      onClick={(e) => {
                        e.preventDefault(); 
                        // navigate("/KnowUserId");
                        InfoAlert2("Coming Soon..!", "info");
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          // navigate("/KnowUserId");
                            InfoAlert2("Coming Soon..!", "info");
                        }
                      }}
                    >
                      <span>Know UserId ?</span>
                      <FiArrowRight className="option-icon" />
                    </a>
                  </Col>

                  <Col xxl={3} xl={3} lg={3} md={4} sm={6} xs={6} className="mb-4">
                    <a href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        openDocumentModal(
                          "APKGBV G.O's",
                          "tet_go"
                        )
                      }
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          openDocumentModal(
                            "APKGBV G.O's",
                            "tet_go"
                          );
                        }
                      }}
                    >
                      <span>GO's</span>
                      <FiArrowRight className="option-icon" />
                    </a>
                  </Col>
                  <Col xxl={3} xl={3} lg={3} md={4} sm={6} xs={6} className="mb-4">
                    <a href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        openDocumentModal(
                          "APKGBV Press Note -2025",
                          "tet_press_note"
                        )
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          openDocumentModal(
                            "APKGBV Press Note -2025",
                            "tet_press_note"
                          );
                        }
                      }}
                    >
                      <span>Press Note</span>
                      <FiArrowRight className="option-icon" />
                    </a>
                  </Col>
                  <Col xxl={3} xl={3} lg={3} md={4} sm={6} xs={6} className="mb-4">
                    <a href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        openDocumentModal(
                          "Notification",
                          "tet_notification"
                        )
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          openDocumentModal(
                            "Schools for girls setup in educationally backward blocks",
                            "tet_notification"
                          );
                        }
                      }}
                    >
                      <span>Notification</span>
                      <FiArrowRight className="option-icon" />
                    </a>
                  </Col>
                  {/* <Col xxl={3} xl={3} lg={3} md={4} sm={6} xs={6} className="mb-4">
                    <a href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/TetResultsPrevious");
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          navigate("/TetResultsPrevious");
                        }
                      }}
                    >
                      <span>Previous TET<br />Result </span>
                      <FiArrowRight className="option-icon" />
                    </a>
                  </Col>
                  <Col xxl={3} xl={3} lg={3} md={4} sm={6} xs={6} className="mb-4">
                    <a href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        openDocumentModal("FAQs & Instructions", "tet_faq")
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          openDocumentModal("FAQs & Instructions", "tet_faq")
                        }
                      }}
                    >
                      <span>FAQs &<br />Instructions </span>
                      <FiArrowRight className="option-icon" />
                    </a>
                  </Col>
                  <Col xxl={3} xl={3} lg={3} md={4} sm={6} xs={6} className="mb-4">
                    <a href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        openDocumentModal(
                          "APTET Schedule -2025",
                          "tet_schedule"
                        )
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          openDocumentModal(
                            "APTET Schedule -2025",
                            "tet_schedule"
                          );
                        }
                      }}
                    >
                      <span>Schedule</span>
                      <FiArrowRight className="option-icon" />
                    </a>
                  </Col>
                  <Col xxl={3} xl={3} lg={3} md={4} sm={6} xs={6} className="mb-4">
                    <a href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        openDocumentModal(
                          "APTET information Bulletien-2025",
                          "tet_bullitin"
                        );
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          openDocumentModal(
                            "APTET information Bulletien-2025",
                            "tet_bullitin"
                          );
                        }
                      }}
                    >
                      <span>Information<br />Bulletien
                      
                      </span>
                      <FiArrowRight className="option-icon" />
                    </a>
                  </Col> */}

                </Row> </div>
            </Col>
            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className="help-bottom">
              <div className="helps-all helps-all1">
                <h2>For any domain related issues</h2>
                <h5><MdOutlineLocalPostOffice className="helps-post" />grievances.kgbv@apschooledu.in</h5>
                <div className="help-numberdiv">
                  <Row>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6} className="mb-3">
                      <div className="d-flex justify-content-center">
                        <span><FaPhoneAlt className="helps-phone" />7075039990</span>
                      </div>
                    </Col>
                   <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6} className="mb-3">
                      <div className="d-flex justify-content-center">
                        <span><FaPhoneAlt className="helps-phone" />7993329115</span>
                      </div>
                    </Col>
                    {/* <Col xxl={4} xl={4} lg={4} md={6} sm={6} xs={6} className="mb-3">
                      <div className="d-flex justify-content-center">
                        <span><FaPhoneAlt className="helps-phone" />7995649286</span>
                      </div>
                    </Col>
                    <Col xxl={2} xl={2} lg={2} md={6} sm={6} xs={6} className="mb-3">
                      <div className="d-flex justify-content-center">
                        <span><FaPhoneAlt className="helps-phone" />7995789286</span>
                      </div>
                    </Col>
                    <Col xxl={2} xl={2} lg={2} md={6} sm={6} xs={6} className="mb-3">
                      <div className="d-flex justify-content-center">
                        <span><FaPhoneAlt className="helps-phone" />9963069286</span>
                      </div>
                    </Col>
                    <Col xxl={2} xl={2} lg={2} md={6} sm={6} xs={6} className="mb-3">
                      <div className="d-flex justify-content-center">
                        <span><FaPhoneAlt className="helps-phone" />9398810958
                         
                        </span>
                      </div>
                    </Col> */}

                  </Row>
                </div>
              </div>
              <div className="call-timediv">
                <p>(Call Time : 10.00 AM to 1.00 PM & 1.30 PM to 05.30 PM on all working days)</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <div className="footer d-flex justify-content-center">
        <p>Designed and developed by</p>
        <a href="https://apcfss.in/" target="_blank">
          <img
            src="../img/apcfss-logo.png"
            className="d-inline-block align-top"
            alt="Tet Dsc"
          /></a>
      </div>
      <Modal show={showData} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Department Login</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EmployeeLogin />
        </Modal.Body>
      </Modal>
      <Modal show={chshow} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Candidate Login</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CandidateLogin />
        </Modal.Body>
      </Modal>


      {/* <DocumentsModal
        show={documentModal.show}
        handleClose={closeDocumentModal}
        title={documentModal.title}
        data={
          documentModal.data === "APTET-2025 Answer Key"
            ? showExamKeys
            : documentModal.data
        }
      
        onItemClick={
          documentModal.title === "User Manual" ? handleManualItemClick : null
        }
      /> */}
      <DocumentsModal
        show={documentModal.show}
        handleClose={closeDocumentModal}
        title={documentModal.title}
        data={documentModal.data}
        onItemClick={
          documentModal.title === "User Manual"
            ? handleManualItemClick
            : null
        }
      />


    </>
  );
}
